interface Props {
    label: string
    onRemove: () => void
}

export const FilterTag = ({ label, onRemove }: Props) => (
    <span className="inline-flex items-center gap-1 px-[8px] py-[4px] rounded-full text-[12px] leading-[16px] font-medium bg-[#E3F3D8] text-[#568C13]">
        {label}
        <button
            type="button"
            onClick={onRemove}
            className="flex items-center justify-center w-4 h-4 text-[#568C13] hover:text-green-900"
            aria-label={`Eliminar ${label}`}
        >
            ×
        </button>
    </span>
)
